/**
 * Layout for Dialog noty for replacing jQuery UI's dialog.
 */

module.exports = function($) {

  $.noty.layouts.swDialog = {
    name: 'swDialog',
    options: {
    },
    container: {
      object: '<ul id="noty_swDialog_layout_container" />',
      selector: 'ul#noty_swDialog_layout_container',
      style: function () {}
    },
    parent: {
      object: '<li />',
      selector: 'li',
      css: {}
    },
    css: {
      display: 'none'
    },
    animation: {}
  };

};
